import { GridColDef, GridRowsProp } from '@mui/x-data-grid';
import { useContext, useEffect, useState } from 'react';
import { AppContext } from '../../../app-context';
import IGridComponent from '../../../components/grid/i-grid.component';
import { generateId, isEmptyArray } from '../../common/util.services';
import { EMPTY_STRING, PAGE_SIZE } from '../../common/constants';
import { getAllProducts } from '../../product/product.services';
import ISearchField from '../../../components/text-component/search-field/i-searchfield.component';

const SelectProductComponent = (props: any) => {
  const appContext = useContext(AppContext);
  const rows: GridRowsProp = [];
  const [enqProduct, setEnqProduct] = useState(rows);
  const [selectedRows, setSelectedRows] = useState<any[]>([]);
  const [searchText, setSearchText] = useState(EMPTY_STRING);
  const columns: GridColDef[] = [
    { field: 'category', headerName: 'Category', filterable: false, sortable: false, width: 150 },
    { field: 'code', headerName: 'Code', filterable: false, sortable: false, width: 60 },
    { field: 'product', headerName: 'Product', filterable: false, sortable: false, width: 200 },
    { field: 'subCode', headerName: 'Sub-Code', filterable: false, sortable: false, width: 85 },
    { field: 'sku', headerName: 'SKU', filterable: false, sortable: false, width: 80 },
    { field: 'color', headerName: 'Color', filterable: false, sortable: false, width: 120 },
    { field: 'size', headerName: 'Size', filterable: false, sortable: false, width: 80 },
    { field: 'pack', headerName: 'Pack', filterable: false, sortable: false, width: 80,
      valueFormatter: (pack: any) => 0 === pack ? 'NA' : pack},
  ];
  const [loading, setLoading] = useState(true);
  const [totalRows, setTotalRows] = useState(0);
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(PAGE_SIZE);

  useEffect(() => {
    if (isEmptyArray(rows)) {
      getAllProducts(searchText, true, page, pageSize, appContext,
        (response: any) => {
          setEnqProduct(response.data.content);
          setTotalRows(response.data.totalElements);
          appContext.setShowLoader(false);
          setLoading(false);
        }, (error: any) => {
          console.log(error);
          appContext.setShowLoader(false);
          setLoading(false);
        });
    }
  }, [searchText, page, pageSize]);

  const onRowSelection = () => {
    if(selectedRows.length < 1) {
      appContext.setDialogMessage('Select a row.');
    }
    else if (props.onRowSelection) {
      for(let i = 0; i < selectedRows.length; ++i) {
        selectedRows[i].id = generateId() + i;
        selectedRows[i].isAmazon = 'NA' !== selectedRows[i].sku ? 1 : 0;
        selectedRows[i].costingStatus = 'New';
        selectedRows[i].conversionStatus = 'Open';
      }
      props.onRowSelection(selectedRows);
    }
  }

  const onPaginationModelChange = (evt: any) => {
    setPage(evt.page);
    setPageSize(evt.pageSize);
  }
  
  const onRowSelectionModelChange = (ids: any) => {
    const selectedIds = new Set(ids);
    const selectedRowData = enqProduct.filter((row) =>
      selectedIds.has(row.rowId)
    );
    setSelectedRows(selectedRowData);
  }

  const search = (e: any) => {
    setSearchText(e);
  }

  return <div className='enquiry-product'>
    <div className='btn-panel'>
      <ISearchField onActionEvent={search} />
      <IGridComponent title='' showAddBtn={false} rows={enqProduct} columns={columns} maxHeight={"50vh"}
        getRowId={(row: any) => row.rowId} disableMultipleRowSelection={false} loading={loading} hideFooter={false}
        paginationType="server" totalRows={totalRows} paginationModelChange={onPaginationModelChange}
        showExtBtn={true} extBtnText={'Select'} extBtnAction={onRowSelection}
        checkboxSelection={true} disableRowSelectionOnClick={true} rowSelectionModelChange={onRowSelectionModelChange} />
    </div>
  </div>
}

export default SelectProductComponent;